import { ActionTree } from 'vuex'
import { IdentificationState } from './types';
import { RootState } from '@/store/types';

export const actions: ActionTree<IdentificationState, RootState> = {
}
